module.exports = __webpack_public_path__ + "static/media/received_475766080375655.jpeg23.4d2edb06.webp";